import React from 'react';
import { Outlet, Link } from "react-router-dom";

export default function About(){
    return(
        <Link to="about" className='text-link'>
            <div className='commonbox about'>
                <h1 className='boxheadings'>Hello<br></br>Rishi Here.</h1>
                <p className='app'>About me</p>
                <img src= {require('./images/rishibw.png')}></img>
            </div>
        </Link>
    );
}